module.exports = __webpack_public_path__ + "static/media/all_the_data.d3459816.png";